import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineArrowLongRight } from "react-icons/hi2"; // Switched to match your Hi2 icon set

const CardsWithBtn = ({ title, description, btn, url, children, iconBg }) => {
  const navigate = useNavigate();

  return (
    <div 
      onClick={() => navigate(url)}
      className="group relative bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-sm hover:shadow-2xl hover:shadow-blue-900/10 hover:-translate-y-2 transition-all duration-500 cursor-pointer flex flex-col h-full overflow-hidden"
    >
      <div className="relative z-10 flex-grow">
        {/* Removed text-white here so the colored icons show up */}
        <div className={`w-20 h-20 rounded-3xl flex items-center justify-center mb-8 transition-all duration-500 group-hover:scale-110 group-hover:rotate-[8deg] ${iconBg}`}>
          {children}
        </div>

        <h1 className="text-xl font-black text-slate-900 mb-3 tracking-tight group-hover:text-blue-600 transition-colors">
          {title}
        </h1>
        
        <p className="text-slate-500 font-medium leading-relaxed mb-10 text-xs">
          {description}
        </p>
      </div>

      <div className="relative z-10 flex items-center justify-between mt-auto pt-6 border-t border-slate-50">
        <span className="font-black text-[10px] uppercase tracking-[0.2em] text-slate-400 group-hover:text-blue-600 transition-colors">
          {btn}
        </span>
        
        <div className="w-12 h-12 rounded-2xl bg-slate-900 flex items-center justify-center text-white transform group-hover:bg-blue-600 group-hover:translate-x-1 transition-all duration-300">
          <HiOutlineArrowLongRight size={24} />
        </div>
      </div>
    </div>
  );
};
export default CardsWithBtn;